import React from "react";
import store from "../../../Store";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  onServerChange,
  onServerReset,
  toggleSiteListFilter,
} from "./SiteList-Actions";
import { unslufigy } from "../../../helpers/StringHelper";
import { Link } from "react-router-dom";
import Button from "../../../components/shared/buttons/Button";
import Select from "../../../components/shared/form/ReactSelect";
import getServerModulesDropdown, {
  resetServerModulesDropdown,
} from "../../../ajax/actions/server-module/server_modules_dropdown_get";

class SuperAdminListFilters extends React.Component {
  // The selected option is kept locally: the store only holds `server_id`, and
  // the option carrying its label can scroll out of the loaded page window.
  state = {
    selectedServer: null,
    serverSearch: ``,
  };

  componentDidMount() {
    store.dispatch(resetServerModulesDropdown());
    store.dispatch(getServerModulesDropdown({ page: 1 }));
  }

  toggleFilter = (e) => {
    store.dispatch(toggleSiteListFilter(e));
  };

  handleServer = (selectedOption) => {
    this.setState({ selectedServer: selectedOption || null });
    if (selectedOption) {
      store.dispatch(onServerChange(selectedOption.value));
    } else {
      store.dispatch(onServerReset());
    }
  };

  // react-select fires this when the menu is scrolled to its last option.
  handleServerScrollToBottom = () => {
    let { serverDropdown } = this.props;
    let { processing, current_page, last_page } = serverDropdown;
    if (processing || current_page >= last_page) return;

    store.dispatch(
      getServerModulesDropdown({
        page: current_page + 1,
        q: this.state.serverSearch,
        append: true,
      })
    );
  };

  // Searching is server-side, so the loaded page window is re-queried instead
  // of being filtered in the browser.
  handleServerInputChange = (value, { action }) => {
    if (action !== `input-change`) return;
    this.setState({ serverSearch: value });
    store.dispatch(
      getServerModulesDropdown({ page: 1, q: value, shouldDebounce: true })
    );
  };

  render() {
    let { title, params, serverDropdown } = this.props;
    let clearable = true;

    return (
      <div className="heading-block pr-60">
        <div className="title-block">
          <h2>{unslufigy(title)}</h2>
        </div>
        <div className="search-bar">
          <input
            type="text"
            className="form-control"
            name="q"
            placeholder={`Search ${unslufigy(title)}`}
            value={params.q}
            onChange={this.toggleFilter}
          />
          <span className="icon-search" />
        </div>

        <div className="select-block" id="filter-datacenter">
          <Select
            name="server_id"
            isClearable={clearable}
            value={this.state.selectedServer}
            options={serverDropdown.options}
            onChange={this.handleServer}
            onInputChange={this.handleServerInputChange}
            onMenuScrollToBottom={this.handleServerScrollToBottom}
            filterOption={null}
            isLoading={serverDropdown.processing}
            placeholder="Filter Server"
            noFormGroup
            border={1}
          />
        </div>

        <div className="button-wrapper">
          <Link to={`/organizations`}>
            <Button
              className="btn-theme btn-dark-blue"
              title={`Deploy ${unslufigy(title)}`}
              text={`Deploy ${unslufigy(title)}`}
            />
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let { superAdminSiteList, getServerModulesDropdown: serverDropdown } = state;

  let { params } = superAdminSiteList.data;

  return { superAdminSiteList, params, serverDropdown };
}
export default withRouter(connect(mapStateToProps)(SuperAdminListFilters));
